export const ApprovesFeatureKey = 'approves';
